import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Clients from "./Tabs/Clients";
import Creatives from "./Tabs/Creatives";
import UpdateOrder from "./Tabs/UpdateOrder";
import Content from "./Tabs/Content";
import NewUser from "../../components/ForPages/NewUser";
import NewCreative from "../../components/ForPages/NewCreative";
import NewOrder from "../../components/ForPages/NewOrder";
import NewContent from "../../components/ForPages/NewContent";
import { useSelector } from "react-redux";
import "./style.css";
import { useDispatch } from "react-redux";

import DashboardFooter from "../../components/Footer/DashboardFooter";
import SideBar from "./SideBar";
import { getUser } from "../../actions/user"

function AdminDashboard() {
  const dispatch = useDispatch();
  const history = useHistory(),
    token = localStorage?.getItem("skiUserToken"),
    [popupDisplay, setPopupDisplay] = useState("none"),
    [newCreativeDisplay, setNewCreativeDisplay] = useState("none"),
    [newOrderDisplay, setNewOrderDisplay] = useState("none"),
    [newContentDisplay, setNewContentDisplay] = useState("none");
    document.title = "Ski design | Admin Dashboard";
  useEffect(() => {
    if (token) {
      try {
        let decodedToken = jwt_decode(token);
        if (decodedToken.AccountType !== "admin") history.push("/");
        
        // GET CURRENT LOGGED USER
        dispatch(getUser(token));

      } catch (err) {
        history.push("/");
        console.error(err);
      }
    } else history.push("/");
  }, [token, history, dispatch]);
  let activeTab = useSelector((state) => state.activeTab);
  const currentUser = useSelector((state) => state.user);

  return (
    <>
      <div>
        <div className="align-items-center justify-content-between d-flex admin-dashboard">
          <SideBar active={activeTab} />
          {activeTab === "clients" ? (
            <Clients currentUser={currentUser} token={token} setPopupDisplay={setPopupDisplay} />
          ) : activeTab === "creatives" ? (
            <Creatives currentUser={currentUser} token={token} setPopupDisplay={setNewCreativeDisplay}/>
          ) : activeTab === "updateOrder" ? (
            <UpdateOrder currentUser={currentUser} token={token} setPopupDisplay={setNewOrderDisplay} />
          ) : activeTab === "content" ? (
            <Content currentUser={currentUser} token={token} setPopupDisplay={setNewContentDisplay}/>
          ) : (
            ""
          )}
        </div>
        <DashboardFooter />
      </div>
      <NewUser display={popupDisplay} setPopupDisplay={setPopupDisplay} />
      <NewCreative
        display={newCreativeDisplay}
        setPopupDisplay={setNewCreativeDisplay}
      />
      <NewOrder
        display={newOrderDisplay}
        setPopupDisplay={setNewOrderDisplay}
      />
      <NewContent
        display={newContentDisplay}
        setPopupDisplay={setNewContentDisplay}
      />
    </>
  );
}

export default AdminDashboard;
